import axios from "axios";
import { logout } from "../../store/actions";
import { store } from "../../index";
import { backendUrl } from "../../config/config";

/*
main - https://utake.ukrpay.net/webadmin/
test - http://192.168.65.156:9710
test-mobile - http://192.168.65.71:4431
*/
//export const API_URL = "http://192.168.65.156:9710";
//export const API_URL = backendUrl;

const $api = axios.create({
  //withCredentials: true,
  baseURL: backendUrl,
});

// for using access token
$api.interceptors.request.use((config) => {
  console.log("STARTED interceptors.request");
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// response
$api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    if (error.response) {
      // Сервер відповів, але щось пішло не так (статус-коди поза діапазоном 2xx)
      console.log("error.response.data: ", error.response.data); // вміст відповіді сервера
    } else if (error.request) {
      // Запит надіслано, але відповідь не отримана
      console.log("error.request: ", error.request);
    } else {
      // Проблема із формуванням запиту на стороні клієнта
      console.log("Ошибка:", error.message); // Повідомлення про помилку
    }
    //console.log('error.config: ', error.config); // Подивимося на конфігурацію запиту
    console.log("error = ", error);
    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
    }

    throw error;
  },
);

export default $api;
